import { render, staticRenderFns } from "./addLocation.vue?vue&type=template&id=5c3dd041&"
import script from "./addLocation.vue?vue&type=script&lang=js&"
export * from "./addLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c3dd041')) {
      api.createRecord('5c3dd041', component.options)
    } else {
      api.reload('5c3dd041', component.options)
    }
    module.hot.accept("./addLocation.vue?vue&type=template&id=5c3dd041&", function () {
      api.rerender('5c3dd041', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/addLocation.vue"
export default component.exports